const validateField = [
  {
    name: "Title",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "FirstName",
    rule: ["required", "alpha"],
    type: "input-submit",
  },
  {
    name: "LastName",
    rule: ["required", "alpha"],
    type: "input-submit",
  },
  {
    name: "Gender",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "DateOfBirth",
    rule: ["required"],
    type: "datepicker",
  },
  {
    name: "MobileNo1",
    rule: ["required"],
    type: "input-submit",
  },
    {name: "EmergencyPhoneNo",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "EmergencyContactName",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "EmergencyContactRelation",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "CorrespondenceAddress",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "CorrespondenceState",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "CorrespondenceCity",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "CorrespondenceCountry",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "PermanentAddress",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "PermanentCity",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "employeeAttachments",
    rule: ["min1"],
    type: "line-level",
  },
  {
    name: "Qualification",
    rule: ["min3"],
    type: "line-level",
  },
  {
    name: "Identities",
    rule: ["min1"],
    type: "line-level",
  },
  {
    name: "PFNomineeName",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "PFNomineeRelation",
    rule: ["required"],
    type: "input-submit",
  },
  {
    name: "BloodGroup",
    rule: ["required"],
    type: "dropdown",
  },
  {
    name: "employment_history",
    rule: ["min1"],
    type: "line-level",
  }
];
export default validateField;
